import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';
export default {
  props: {
    teacherList: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      swiper: null
    };
  },

  mounted() {
    this.swiper = new Swiper('.swiper-container', {
      slidesPerView: 4,
      //设置slider容器能够同时显示的slides数量(carousel模式)。
      centeredSlides: true,
      //设置活动块居中
      slideToClickedSlide: true,
      // 点击的slide会居中
      loopAdditionalSlides: 2,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      effect: 'coverflow',
      grabCursor: true,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 2,
        slideShadows: false
      }
    });
  },

  watch: {},
  methods: {},

  created() {}

};